module.exports = __webpack_public_path__ + "img/image_02sp.20fb73be.jpg";